// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SummaryReport.css - Cleaned up */

/* Container Styling */
.summary-report {
  padding: 20px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9; /* Light background for better contrast */
  border-radius: 8px; /* Rounded corners */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  overflow: hidden; /* Important for containing children and scroll-wrapper */
}

/* Table Scroll Wrapper for Horizontal Scrolling */
.table-scroll-wrapper {
  overflow-x: auto; /* This is the key for horizontal scrolling */
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 15px;
}

/* Table Styling */
.summary-report table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px; /* Ensures table is wide enough to scroll if content is small */
}

/* Table Header and Data Cell Styling */
.summary-report th,
.summary-report td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  white-space: nowrap; /* Prevents text from wrapping, forcing horizontal overflow */
}

.summary-report th {
  background-color: #e4f0e4;
  color: #333;
  font-weight: bold;
  cursor: pointer;
  position: relative;
}

.summary-report-tbody {
  font-size: 10px; /* Applied to the tbody directly */
}

.summary-report-body {
  font-size: 10px;
  padding: 8px 5px;
  height: 20px;
}

.summary-report table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.summary-report table tr:hover {
  background-color: #f1f1f1;
}

/* Header Cell and Dropdown Specific Styles */
.header-cell {
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  font-size: 8px; /* This font size is for the text inside header-content */
}

.dropdown-toggle {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  display: flex; /* To center the image */
  align-items: center; /* To center the image */
  justify-content: center; /* To center the image */
}

.dropdown-toggle img {
  width: 16px; /* Match width/height from JSX */
  height: 16px; /* Match width/height from JSX */
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  padding: 4px;
  min-width: 150px; /* Give dropdown a reasonable minimum width */
}

.dropdown input {
  width: calc(100% - 8px); /* Account for padding */
  padding: 4px;
  margin-bottom: 4px;
  box-sizing: border-box;
}

.dropdown-options {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 150px;
  overflow-y: auto;
}

.dropdown-options li {
  padding: 4px 8px;
  cursor: pointer;
  font-size: 8px; /* Match header-content font size for consistency */
}

.dropdown-options li:hover {
  background: #f0f0f0;
}


/* Pagination Styling */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 15px; /* Add some space above pagination */
}

.rows-per-page {
  display: flex;
  align-items: center; /* Vertically align items */
  padding-right: 35px;
}

.rows-per-page-row {
  padding-right: 12px;
  color: gray; /* Match other pagination text color */
}

.rows-per-page select {
  font-size: 14px;
  border: 1px solid #ccc; /* Add a subtle border */
  border-radius: 4px;
  padding: 4px 8px;
  width: auto;
  background-color: white;
}

.rows-per-page select:focus {
  border-color: #007bff; /* Highlight on focus */
  outline: none;
}

.pagination button {
  border: none;
  cursor: pointer;
  background-color: transparent;
  display: flex; /* To center the image */
  align-items: center; /* To center the image */
  justify-content: center; /* To center the image */
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination span {
  font-size: 14px;
  color: #333;
  padding: 0 5px; /* Add some padding around the page number */
}

.Arrow_btn {
  height: 20px;
  width: 20px; /* Ensure consistent size */
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardSection/SummaryReport/SummaryReport.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB,EAAE,yCAAyC;EACpE,kBAAkB,EAAE,oBAAoB;EACxC,yCAAyC,EAAE,kBAAkB;EAC7D,gBAAgB,EAAE,yDAAyD;AAC7E;;AAEA,kDAAkD;AAClD;EACE,gBAAgB,EAAE,6CAA6C;EAC/D,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB,EAAE,+DAA+D;AACnF;;AAEA,uCAAuC;AACvC;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB,EAAE,6DAA6D;AACpF;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,kCAAkC;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc,EAAE,yDAAyD;AAC3E;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa,EAAE,wBAAwB;EACvC,mBAAmB,EAAE,wBAAwB;EAC7C,uBAAuB,EAAE,wBAAwB;AACnD;;AAEA;EACE,WAAW,EAAE,gCAAgC;EAC7C,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE,uBAAuB,EAAE,wBAAwB;EACjD,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAE,mDAAmD;AACrE;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,2BAA2B;EAChD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW,EAAE,sCAAsC;AACrD;;AAEA;EACE,eAAe;EACf,sBAAsB,EAAE,wBAAwB;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,qBAAqB,EAAE,uBAAuB;EAC9C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,aAAa,EAAE,wBAAwB;EACvC,mBAAmB,EAAE,wBAAwB;EAC7C,uBAAuB,EAAE,wBAAwB;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc,EAAE,4CAA4C;AAC9D;;AAEA;EACE,YAAY;EACZ,WAAW,EAAE,2BAA2B;AAC1C","sourcesContent":["/* SummaryReport.css - Cleaned up */\n\n/* Container Styling */\n.summary-report {\n  padding: 20px;\n  font-family: Arial, sans-serif;\n  background-color: #f9f9f9; /* Light background for better contrast */\n  border-radius: 8px; /* Rounded corners */\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n  overflow: hidden; /* Important for containing children and scroll-wrapper */\n}\n\n/* Table Scroll Wrapper for Horizontal Scrolling */\n.table-scroll-wrapper {\n  overflow-x: auto; /* This is the key for horizontal scrolling */\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-bottom: 15px;\n}\n\n/* Table Styling */\n.summary-report table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 800px; /* Ensures table is wide enough to scroll if content is small */\n}\n\n/* Table Header and Data Cell Styling */\n.summary-report th,\n.summary-report td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  white-space: nowrap; /* Prevents text from wrapping, forcing horizontal overflow */\n}\n\n.summary-report th {\n  background-color: #e4f0e4;\n  color: #333;\n  font-weight: bold;\n  cursor: pointer;\n  position: relative;\n}\n\n.summary-report-tbody {\n  font-size: 10px; /* Applied to the tbody directly */\n}\n\n.summary-report-body {\n  font-size: 10px;\n  padding: 8px 5px;\n  height: 20px;\n}\n\n.summary-report table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.summary-report table tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* Header Cell and Dropdown Specific Styles */\n.header-cell {\n  position: relative;\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 5px;\n  font-size: 8px; /* This font size is for the text inside header-content */\n}\n\n.dropdown-toggle {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  display: flex; /* To center the image */\n  align-items: center; /* To center the image */\n  justify-content: center; /* To center the image */\n}\n\n.dropdown-toggle img {\n  width: 16px; /* Match width/height from JSX */\n  height: 16px; /* Match width/height from JSX */\n}\n\n.dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background: white;\n  border: 1px solid #ccc;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n  padding: 4px;\n  min-width: 150px; /* Give dropdown a reasonable minimum width */\n}\n\n.dropdown input {\n  width: calc(100% - 8px); /* Account for padding */\n  padding: 4px;\n  margin-bottom: 4px;\n  box-sizing: border-box;\n}\n\n.dropdown-options {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  max-height: 150px;\n  overflow-y: auto;\n}\n\n.dropdown-options li {\n  padding: 4px 8px;\n  cursor: pointer;\n  font-size: 8px; /* Match header-content font size for consistency */\n}\n\n.dropdown-options li:hover {\n  background: #f0f0f0;\n}\n\n\n/* Pagination Styling */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin-top: 15px; /* Add some space above pagination */\n}\n\n.rows-per-page {\n  display: flex;\n  align-items: center; /* Vertically align items */\n  padding-right: 35px;\n}\n\n.rows-per-page-row {\n  padding-right: 12px;\n  color: gray; /* Match other pagination text color */\n}\n\n.rows-per-page select {\n  font-size: 14px;\n  border: 1px solid #ccc; /* Add a subtle border */\n  border-radius: 4px;\n  padding: 4px 8px;\n  width: auto;\n  background-color: white;\n}\n\n.rows-per-page select:focus {\n  border-color: #007bff; /* Highlight on focus */\n  outline: none;\n}\n\n.pagination button {\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  display: flex; /* To center the image */\n  align-items: center; /* To center the image */\n  justify-content: center; /* To center the image */\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination span {\n  font-size: 14px;\n  color: #333;\n  padding: 0 5px; /* Add some padding around the page number */\n}\n\n.Arrow_btn {\n  height: 20px;\n  width: 20px; /* Ensure consistent size */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
